import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import aboutImage from '../../assets/az/w.png';
import abutImage from '../../assets/az/ww.png';
import boutImage from '../../assets/az/awe.png';

import atImage from '../../assets/az/bleed.png';
import aoImage from '../../assets/az/gig.png';
import aotmage from '../../assets/az/falsk.png';
import aotIage from '../../assets/az/gyg.png';

import gh from '../../assets/az/ghgh.png';
import ghi from '../../assets/az/ghghgh.png';

import './ImageSlider.css';

const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 9,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 768, // This means at a viewport width of 768px and below
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    // You can add more breakpoints here if needed
  ],
};

const ImageSlider = () => {
  return (
    <Slider {...settings}>
      <div>
        <img src={aboutImage} alt="About page image 1" />
      </div>

      <div>
        <img src={abutImage} alt="About page image 2" />
      </div>
      <div>
        <img src={boutImage} alt="About page image 3" />
      </div>
      <div>
        <img src={aotIage} alt="About page image 3" />
      </div>

      <div>
        <img src={aotmage} alt="About page image 3" />
      </div>

      <div>
        <img src={aoImage} alt="About page image 3" />
      </div>
      <div>
        <img src={atImage} alt="About page image 3" />
      </div>

      <div>
        <img src={gh} alt="About page image 3" />
      </div>

      <div>
        <img src={ghi} alt="About page image 3" />
      </div>
    </Slider>
  );
};

export default ImageSlider;
